import React from 'react'

const TimeGridHeader = ({ manageViewHours }) => (
  <div>
    <div>
      <button
        type="button" 
        className="lnr lnr-chevron-up rbc-time-header-arrow"
        onClick={() => manageViewHours('up')}
      />
    </div>
    <div>
      <button
        type="button"
        className="lnr lnr-chevron-down rbc-time-header-arrow"
        onClick={() => manageViewHours('down')}
      />
    </div>
  </div>
)

export default TimeGridHeader
